import { useMutation } from '@libs/use';

import * as API from '../requests';

export default function useDeleteDepositReceiptQuery({ onReject, onSuccess }) {
  const {
    execute: deleteReceipt,
    isPending: isLoadingDeleteReceipt,
    ...query
  } = useMutation((requestId: string) => API.deleteDepositReceipt(requestId), {
    onReject,
    onSuccess,
  });

  return { deleteReceipt, isLoadingDeleteReceipt, ...query };
}
